var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewAgentSubmissionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#NewAgentSubmissionIcon_svg__clip0_3832_561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.945c0-11.046 8.954-20 20-20s20 8.954 20 20v6c0 3.8-2.65 6.982-6.203 7.797A8.003 8.003 0 0126 40.945h-8a2 2 0 010-4h8a4.001 4.001 0 003.693-2.46A6.002 6.002 0 0126 28.945v-8a6 6 0 016-6h2c.293 0 .58.021.862.062C32.504 9.11 26.738 4.945 20 4.945c-6.738 0-12.503 4.165-14.862 10.062.282-.041.57-.062.862-.062h2a6 6 0 016 6v8a6 6 0 01-6 6 8 8 0 01-8-8v-6zm4 6a4 4 0 004 4 2 2 0 002-2v-8a2 2 0 00-2-2H6a2 2 0 00-2 2v6zm32-6a2 2 0 00-2-2h-2a2 2 0 00-2 2v8a2 2 0 002 2 4 4 0 004-4v-6z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "NewAgentSubmissionIcon_svg__clip0_3832_561"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .945)",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgNewAgentSubmissionIcon;